<template>
    <div class="popup-menu-wrapper" @click.stop="onClick">
        <slot name="handle"></slot>

        <portal to="body">
            <popup-menu-content
                v-if="show"
                :coords="coords"
                :vertical-flow="verticalFlow"
                :vertical-offset="verticalOffset"
                :horizontal-flow="horizontalFlow"
                :horizontal-offset="horizontalOffset"
                :close-on-next-click="closeOnNextClick"
                :close-on-outside-click="closeOnOutsideClick"
                :width="width"
                @close="show = false"
            >
                <slot></slot>
            </popup-menu-content>
        </portal>
    </div>
</template>

<script>
import PopupMenuContent from './PopupMenuContent.vue';
import { bus } from './events';

export default {
    components: { PopupMenuContent },
    props: {
        closeOnNextClick: {
            type: Boolean,
            default: true,
        },
        closeOnOutsideClick: {
            type: Boolean,
            default: false,
        },
        verticalFlow: {
            type: String,
            default: 'down',
        },
        verticalOffset: {
            type: Number,
            default: 0,
        },
        horizontalFlow: {
            type: String,
            default: 'right',
        },
        horizontalOffset: {
            type: Number,
            default: 0,
        },
        width: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            show: false,
            coords: null,
        };
    },
    created() {
        bus.on('close', () => (this.show = false));
    },
    methods: {
        onClick(e) {
            const element = e.target;

            const rect = element.getBoundingClientRect(),
                scrollLeft =
                    window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop =
                    window.pageYOffset || document.documentElement.scrollTop;

            this.coords = {
                top: rect.top + scrollTop + element.offsetHeight,
                left: rect.left + scrollLeft,
            };

            this.show = true;
        },
    },
};
</script>
